import { render, staticRenderFns } from "./authCch.vue?vue&type=template&id=585ec717&scoped=true&"
import script from "./authCch.vue?vue&type=script&lang=js&"
export * from "./authCch.vue?vue&type=script&lang=js&"
import style0 from "./authCch.vue?vue&type=style&index=0&id=585ec717&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ec717",
  null
  
)

export default component.exports